import type { RegionApi } from 'components/discover/contexts/RegionContext';
import { RegionContext } from 'components/discover/contexts/RegionContext';
import { DiscoverGrid } from 'components/discover/DiscoverGrid';
import { useAppSelector } from 'hooks/useAppSelector';
import { useNavigateTo } from 'hooks/useNavigateTo';
import { FC, useCallback, useMemo } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

import type { WelcomePageProps } from './WelcomePage.connect';

export const WelcomePageComponent: FC<WelcomePageProps> = ({ theme, region, onRegionChanged, availableRegions }) => {
  const navigateToStatic = useNavigateTo('/static');
  const openNewStaticQuote = useCallback(() => {
    navigateToStatic();
    logAnalytics.trackEvent('Discover', 'Open New Static Screen');
  }, [navigateToStatic]);

  const { hasGivenConsentToVideo = false } = useAppSelector(state => state.userConsent);

  const countryApi = useMemo<RegionApi>(
    () => ({ region, onRegionChanged, availableRegions }),
    [region, onRegionChanged, availableRegions],
  );

  return (
    <div className="page-container h-100 overflow-y-auto" data-e2e="welcome-page-container">
      <RegionContext.Provider value={countryApi}>
        <DiscoverGrid theme={theme} onNewQuote={openNewStaticQuote} hasGivenConsentToVideo={hasGivenConsentToVideo} />
      </RegionContext.Provider>
    </div>
  );
};
WelcomePageComponent.displayName = 'WelcomePage';
